/*
 * @Author: yanglin
 * @Date: 2021-10-13 08:58:06
 * @LastEditTime: 2021-10-17 12:36:02
 * @LastEditors: yanglin
 * @Description:
 * @FilePath: /huazhan/src/router/index.js
 */
import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

export default new Router({
  //  linkActiveClass:'active',
  //  linkExactActiveClass:'',
  routes: [
    {
      path: '/',
      redirect: {
        name: "Home",
      },
      component: () => import("@/layout/layout.vue"),
      children: [
        {
          path: '/home',
          name: 'Home',
          component: () => import("@/views/home"),
        },
        {
          path: '/move',
          name: 'Move',
          component: () => import("@/views/move"),
        },

        {
          path: '/analysis',
          name: 'analysis',
          component: () => import("@/views/analysis/index"),
        },
        {
          path: '/personalCenterHome',
          name: 'personalCenterHome',
          component: () => import("@/views/personal-center/personal-center-home"),
        },
        {
          path: '/CostCenter',
          name: 'CostCenter',
          component: () => import("@/views/cost-center/cost-center"),
        },

        {
          path: '/comparison',
          name: 'comparison',
          component: () => import("@/views/comparison"),
        },
        {
          path: '/info',
          name: 'info',
          component: () => import("@/views/info/index"),
        },
        {
          path: '/information',
          name: 'information',
          component: () => import("@/views/information/index"),
        },
        {
          path: '/shielding',
          name: 'shielding',
          component: () => import("@/views/shielding/index"),
        },
        {
          path: '/renewable',
          name: 'renewable',
          component: () => import("@/views/renewable/index"),
        },
      ]
    },

      {
        path: '/login',
        name: 'login',
        meta: {
          requireAuth: true
        },
        component: () => import('@/views/login')
      }


  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js